var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block" },
    [
      _vm.hasHeader
        ? _c("div", { staticClass: "block-header", style: _vm.headerStyle }, [
            _c("div", { staticClass: "header-info" }, [
              _c(
                "h4",
                { staticClass: "block-header-title is-size-4" },
                [_vm._t("header", [_vm._v("Default Header")])],
                2
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "is-marginless is-size-7" },
                [_vm._t("subheader")],
                2
              )
            ]),
            _vm._v(" "),
            _vm.hasActions
              ? _c("div", { staticClass: "actions" }, [_vm._t("actions")], 2)
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }